export default "__VITE_ASSET__KhEjda_V__"